import './index.erb';
import './index.rb';

const SIGNUP_BANNER_EVENT = 'account created banner';
const SIGNUP_BANNER_EXCEPT = ['user', 'iterable', 'appcues'];

class SignupBanner {
  constructor() {
    this.close = $('#js-signup-banner-close');
    this.button = $('#js-signup-banner');
  }

  init() {
    this.close.on('click', e => $(e.currentTarget).parent().hide());
    this.button.on('click', e => {
      const button = $(e.currentTarget);

      const isDataEmit = button.attr('data-emit') || false;

      const flag = button.attr('data-flag') || 'flag-default';
      const theme = button.attr('data-theme') || 'theme-default';
      const position = button.attr('data-position') || 'position-default';

      if (isDataEmit) {
        this.dispatchTrackerEvent('clicked', {
          flag,
          theme,
          position
        });
      }
    });
  }

  dispatchTrackerEvent(event, params = {}) {
    const data = {
      eventName: `${SIGNUP_BANNER_EVENT} ${event}`,
      except: SIGNUP_BANNER_EXCEPT,
      data: { ...params }
    };

    try {
      UserTracker.emit('event', data);
    } catch (error) {
      Rollbar.error('dispatchTrackerEvent', error);
    }
  }
}

(() => {
  new SignupBanner().init();
})();
